<template>
  <v-chip color="grey lighten-3" close @click:close="removeFilter">
    <v-avatar>
      <v-progress-circular
        :rotate="-90"
        :size="28"
        :width="2"
        :value="progressValue"
        :color="progressColour"
        v-if="filter.icon === 'progress_full' || filter.icon === 'progress_empty'"
      >
        {{ progressValue }}
      </v-progress-circular>
      <v-icon v-else>{{ filter.icon }}</v-icon>
    </v-avatar>
    <strong>{{ filter.text }}</strong>
  </v-chip>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'abf-nullable-filter-chip',
  data: () => ({}),
  props: ['filter'],
  computed: {
    ...mapGetters(['ReferralPageFilters']),
    progressValue: function() {
      return this.filter.icon === 'progress_full' ? 100 : 0;
    },
    progressColour: function() {
      return this.filter.icon === 'progress_full' ? 'accent' : 'grey';
    }
  },
  methods: {
    ...mapActions(['setReferralFilters', 'getReferralsPage']),
    removeFilter() {
      this.setReferralFilters({ [this.filter.value]: null }).then(() => this.getReferralsPage());
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
